<template>
    <b-container>
      <b-row>
        <b-col cols="6">
           <p style="padding-top:40px;text-align:right;">
            <router-link :to="{name: 'SinglePay'}"><button type="button" class="btn btn-secondary btn-lg">Tek Çekim Ödeme</button></router-link>
            </p>
            <p class="p-left">
              <small>Tüm banka kredi kartları ile tek çekim ödeme yapmak için buradan.</small>
            </p>
        </b-col>
        <b-col cols="6">
          <p style="padding-top:40px;text-align:left;">
              <router-link :to="{name: 'InstallmentPay'}">
                <button type="button" class="btn btn-primary btn-lg">Taksitli Ödeme
                </button>
              </router-link>
              </p>
                <p class="p-right"><small>Yalnızca Garanti Bonus Kartlara 6 Taksit uygulanmaktadır.</small>
              </p>
          <p></p>
        </b-col>
        <b-col cols="12">
          <p style="text-align:center;"><img class="home-card" src="@/assets/images/visamaster.jpeg"></p>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
  export default{
    data(){
      return{
      }
    },
    components:{
    }
  }
</script>